"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerPaginationView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ServerPaginationView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: end;\n"])));

exports.ServerPaginationView = ServerPaginationView;

//# sourceMappingURL=ServerPagination.style.js.map